import { render, staticRenderFns } from "./AppointmentDetailsComponent.vue?vue&type=template&id=d19f5bde&scoped=true"
import script from "./AppointmentDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetailsComponent.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentDetailsComponent.vue?vue&type=style&index=0&id=d19f5bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19f5bde",
  null
  
)

export default component.exports